const actions = {
  GET_CHATR_RECHARGE_REPORT_REQUEST_LIST:
    "GET_CHATR_RECHARGE_REPORT_REQUEST_LIST",
  GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_SUCCESSFUL:
    "GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_SUCCESSFUL",
  GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_FAILED:
    "GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_FAILED",

  getChatrRechargeReportRequestList: (searchData) => ({
    type: actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST,
    payload: { searchData },
  }),
  getChatrRechargeReportRequestListSuccessful: (data) => ({
    type: actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_SUCCESSFUL,
    payload: { data },
  }),
  getChatrRechargeReportRequestListFailed: (error) => ({
    type: actions.GET_CHATR_RECHARGE_REPORT_REQUEST_LIST_FAILED,
    payload: { error },
  }),
};

export default actions;
